var map = {
	"./menu_de.json": [
		98078,
		8078
	],
	"./menu_en.json": [
		1542,
		1542
	],
	"./menu_hy.json": [
		7174,
		7174
	],
	"./menu_ru.json": [
		31376,
		1376
	],
	"./menu_ua.json": [
		33683,
		3683
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 82113;
module.exports = webpackAsyncContext;